export type Product = {
  slug: string;
  name: string;
  description: string;
  price: number;
  image: string;
  hoverImage?: string;
  /** Galeri — birden çok fotoğraf. Boşsa [image, hoverImage] kullanılır. */
  images?: string[];
  badge?: "cok-satan" | "yeni" | "indirimli" | null;
  category: string;
  inStock: boolean;
  originalPrice?: number;
  /** Adetli stok — tanımsız/null ise sınırsız sayılır */
  stockQty?: number | null;
  /** Kargo desi hesabı (gram) — tanımsızsa 250 gr varsayılır */
  weightGrams?: number | null;
  /** DB kayıt güncelleme zamanı (ISO) — sitemap lastmod kaynağı; kod kataloğunda yoktur */
  updatedAt?: string;
};

// NOT: Görseller public/images/products altındaki gerçek dosyalardır.
// Ürün adları ambalaj üzerindeki marka + ürün + hacim bilgisini birebir yansıtır (SEO + iade şikâyetlerini önler).

export const products: Product[] = [
  // ── Protez Tırnak ──────────────────────────────────────────────
  {
    slug: "qnail-builder-gel-50ml",
    name: "QNAIL Professional Builder Gel No:13 – Protez Tırnak Jeli 50 ml",
    description:
      "QNAIL Builder Gel No:13 ile salon kalitesinde protez tırnak: UV/LED uyumlu, akmayan kıvam, doğal pembe ton. 50 ml protez tırnak jeli.",
    price: 689.99, originalPrice: 750,
    image: "/images/products/builder-gel.png",
    hoverImage: "/images/products/builder-gel-kartela-1.png",
    images: ["/images/products/builder-gel.png", "/images/products/builder-gel-kartela-1.png", "/images/products/builder-gel-kartela-2.png"],
    badge: "cok-satan",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "qnail-soft-gel-tips-oval-medium-550",
    name: "QNAIL Professional Soft Gel Tips – Oval Medium 550'li Protez Jel Tip Kutusu",
    description:
      "Qnail Professional 550'li oval medium soft jel tip: esnek, kırılmaya dayanıklı, french uyumlu. Hızlı protez tırnak için numaralı jel tip seti.",
    price: 240,
    image: "/images/products/oval-medium-soft-gel-tips.jpg",
    badge: "cok-satan",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "qnail-sculpture-jel-beyaz-02-15gr",
    name: "QNAIL Professional Sculpture Hamur Jel – Beyaz No:02 15 gr",
    description:
      "Qnail Professional beyaz sculpture hamur jel: protez uzatma ve şekillendirme için akmayan doku. UV/LED uyumlu 15 gr protez tırnak jeli.",
    price: 234.99,
    image: "/images/products/sculpter-builder-gel-no-2.png",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "qnail-mbqn-tips-glue-7gr",
    name: "Qnail Professional MBQN Pro's Choice Fırçalı Protez Tırnak Yapıştırıcısı – Tips Glue 7 g",
    description:
      "Qnail Professional protez sistemleriyle uyumlu fırçalı tırnak yapıştırıcı: jel tip ve takma tırnak için güçlü tutuş. Pratik 7 g tips glue ile hızlı protez uygulaması.",
    price: 62.99,
    image: "/images/products/glue.png",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "protez-jel-tip-natural",
    name: "Qnail Professional Protez Jel Tip Natural – 500'lü Şeffaf Jel Tip Seti (10 Beden)",
    description:
      "Qnail Professional builder jel ile tam uyumlu 500'lü natural jel tip: ince kenar, kolay törpüleme, 10 beden. Hızlı protez tırnak uzatma seti.",
    price: 349.0,
    image: "/images/products/protez/protez-jel-tip-natural.jpg",
    hoverImage: "/images/products/protez/protez-jel-tip-natural-hover.jpg",
    images: ["/images/products/protez/protez-jel-tip-natural.jpg", "/images/products/protez/protez-jel-tip-natural-hover.jpg"],
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "protez-akrilik-pudra-pembe",
    name: "QNAIL Professional Protez Akrilik Pudra Pembe – Yüksek Kapatıcı Tırnak Pudrası",
    description:
      "Qnail Professional tozutmayan pembe akrilik pudra: protez tırnak güçlendirme ve uzatma için yüksek kapatıcılık. Pürüzsüz protez akrilik bitişi.",
    price: 429.0,
    image: "/images/products/protez/protez-akrilik-pudra-pembe.jpg",
    hoverImage: "/images/products/protez/protez-akrilik-pudra-pembe-hover.jpg",
    images: ["/images/products/protez/protez-akrilik-pudra-pembe.jpg", "/images/products/protez/protez-akrilik-pudra-pembe-hover.jpg"],
    badge: "cok-satan",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "protez-polygel-builder-clear",
    name: "Qnail Professional Protez Polygel Builder Clear – Şeffaf Tırnak Jeli",
    description:
      "Qnail Professional protez serisiyle uyumlu şeffaf builder polygel: akmayan kıvam, kolay şekillendirme, doğal güçlendirme. Protez ve düzeltme için clear polygel.",
    price: 265.99,
    image: "/images/products/mixgel-clear.png",
    hoverImage: "/images/products/mixgel-clear-kartela.png",
    images: ["/images/products/mixgel-clear.png", "/images/products/mixgel-clear-kartela.png"],
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "protez-form-sablonu-100",
    name: "Qnail Professional Protez Tırnak Form Şablonu – 100'lü Yapışkanlı Kağıt Form",
    description:
      "Qnail Professional jel ve akrilikle uyumlu numaralı ölçülü 100'lü protez form: altın ızgaralı, yapışkanlı kağıt şablon ile evde salon tipi uzatma.",
    price: 129.0,
    image: "/images/products/protez/protez-form-sablonu-100.jpg",
    hoverImage: "/images/products/protez/protez-form-sablonu-100-hover.jpg",
    images: ["/images/products/protez/protez-form-sablonu-100.jpg", "/images/products/protez/protez-form-sablonu-100-hover.jpg"],
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "protez-tirnak-yapistirici",
    name: "Qnail Professional Protez Tırnak Yapıştırıcısı – Jel Tip Glue 10 g Fırçalı",
    description:
      "Qnail Professional soft gel tiplerle uyumlu 10 g fırçalı protez yapıştırıcı: jel tip ve protez tırnak için hızlı, güçlü tutuş. Taşmayan hassas fırça kapak.",
    price: 70.99,
    image: "/images/products/tips-yapistiricisi.png",
    hoverImage: "/images/products/protez/protez-tirnak-yapistirici-hover.jpg",
    images: ["/images/products/tips-yapistiricisi.png", "/images/products/protez/protez-tirnak-yapistirici-hover.jpg"],
    category: "Protez Tırnak",
    inStock: true,
  },
  // ── Kalıcı Oje (renk + baz + üst kat) ──────────────────────────
  {
    slug: "uno-gel-polish-bronz-12ml",
    name: "Qnail Professional UNO LED/UV Gel Polish – Bronz Kalıcı Oje 12 ml",
    description:
      "Qnail Professional kalıcı oje sistemleriyle uyumlu metalik bronz jel oje: yoğun pigment, tek katta opak, LED/UV uyumlu. 12 ml soak-off ile ışıltılı manikür.",
    price: 160,
    image: "/images/products/uno-color-gel.png",
    badge: "cok-satan",
    category: "Kalıcı Oje",
    inStock: true,
  },
  {
    slug: "qnail-uno-super-black-15ml",
    name: "Qnail Professional UNO Super Black – Siyah Kalıcı Oje LED/UV Gel Polish 15 ml",
    description:
      "Qnail Professional güvencesiyle yoğun siyah kalıcı oje: tek katta opak, soak-off formül. French, nail art ve tam kaplama için 15 ml siyah jel oje.",
    price: 160,
    image: "/images/products/uno-black.png",
    category: "Kalıcı Oje",
    inStock: true,
  },
  {
    slug: "qnail-uno-elastik-base-15ml",
    name: "Qnail Professional UNO Elastik Base Coat – Kalıcı Oje Altı Esnek Güçlendirici Baz 15 ml",
    description:
      "Qnail Professional esnek yapılı güçlendirici base coat: kırılgan tırnakta kalıcı oje tutuşunu artırır. LED/UV uyumlu elastik baz 15 ml.",
    price: 165,
    image: "/images/products/elastic-base-coat.png",
    category: "Kalıcı Oje",
    inStock: true,
  },
  {
    slug: "qnail-uno-strong-base-50ml",
    name: "Qnail Professional UNO Strong Base Coat – Kalıcı Oje Güçlü Tutuşlu Baz Jel 50 ml",
    description:
      "Qnail Professional strong base: kalıcı oje ve protez altında maksimum tutuş. Ekonomik 50 ml LED/UV baz jel, salon ve ev kullanımı için.",
    price: 335,
    image: "/images/products/rubber-base-gel.png",
    category: "Kalıcı Oje",
    inStock: true,
  },
  {
    slug: "qnail-uno-diamond-shield-top-coat",
    name: "QNAIL Professional UNO Diamond Shield Top Coat – LED/UV 15 ml",
    description:
      "Qnail Professional elmas parlaklığında kalıcı oje top coat: sararma yapmaz, LED/UV uyumlu. Uzun süre parlak koruyucu üst kat 15 ml.",
    price: 159.9,
    image: "/images/products/diamond-shield-top-coat.png",
    badge: "cok-satan",
    category: "Kalıcı Oje",
    inStock: true,
  },
  // ── Tırnak Bakımı (hazırlık + çıkarma) ─────────────────────────
  {
    slug: "qnail-uno-nail-prep-dehydrator",
    name: "QNAIL Professional UNO Nail Prep Dehydrator pH – Tırnak Kurutucu 15 ml",
    description:
      "Qnail Professional kalıcı oje öncesi tırnak hazırlığı: UNO Nail Prep fazla yağı ve nemi alır, tutuşu artırır. Baz öncesi 15 ml dehydrator.",
    price: 159.9,
    image: "/images/products/dehydrator.png",
    category: "Tırnak Bakımı",
    inStock: true,
  },
  {
    slug: "qnail-uno-magic-remover",
    name: "Qnail Professional UNO Magic Remover – Kalıcı Oje Çıkarıcı Jel 15 ml",
    description:
      "Qnail Professional kalıcı oje ve gel polish sökücü: çatlatma formülüyle pratik çıkarma, tırnağı yormaz. Tırnak dostu magic remover 15 ml.",
    price: 175,
    image: "/images/products/uno-magicremove.png",
    category: "Tırnak Bakımı",
    inStock: true,
  },
  // ── Nail Art ───────────────────────────────────────────────────
  {
    slug: "qnail-cat-eye-magnet-6li",
    name: "QNAIL 6'sı Bir Arada Tırnak Cat Eye Nail Art Magneti",
    description:
      "Qnail Professional kedi gözü ojeler için 6 desenli tırnak magneti: çizgi, yıldız ve degrade efekt. Cat eye magnet ile evde salon efekti.",
    price: 165.0, originalPrice: 169,
    image: "/images/products/cat-eye-magnet.png",
    badge: "cok-satan",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "qnail-inci-tozu-pigment",
    name: "QNAIL İnci Tozu Nail Art Pigmenti – Gri Yeşil Tırnak Tozu + Aplikatör",
    description:
      "Qnail Professional sedefli gri-yeşil tırnak pigmenti: çift uçlu aplikatörle kolay inci efekti. Jel oje üstünde krom-incili nail art bitişi.",
    price: 40.44, originalPrice: 41.27,
    image: "/images/products/inci-tozu-gri.png",
    category: "Nail Art",
    inStock: true,
  },
  // ── Aksesuar ───────────────────────────────────────────────────
  {
    slug: "protez-frez-uc-seti",
    name: "Qnail Professional Protez Tırnak Frez Uç Seti 5'li – Elektrikli Törpü Başlık Seti",
    description:
      "Qnail Professional protez uygulamalarıyla uyumlu 5'li frez uç seti: şekillendirme, tırnak eti temizliği ve pürüzsüzleştirme için elektrikli törpü başlıkları. Salon ve ev kullanımı.",
    price: 249.0,
    image: "/images/products/protez/protez-frez-uc-seti.jpg",
    hoverImage: "/images/products/protez/protez-frez-uc-seti-hover.jpg",
    images: ["/images/products/protez/protez-frez-uc-seti.jpg", "/images/products/protez/protez-frez-uc-seti-hover.jpg"],
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "qnail-french-stamper",
    name: "Qnail Professional French Tırnak Desen Damgalama Aleti – Şeffaf Nail Art Stamper",
    description:
      "Qnail Professional şeffaf silikon french stamper: tırnak desen ve french transferinde net baskı. Nail art damgalama için pratik stamper aleti.",
    price: 23.99,
    image: "/images/products/uno-stamp.png",
    category: "Aksesuar",
    inStock: true,
  },
  {
    slug: "uno-kalici-oje-156-renk-10-ml-plhsgel",
    name: "Qnail Professional UNO Kalıcı Oje 156 Renk 10 ml",
    description:
      "Qnail Professional UNO Kalıcı Oje 156 Renk 10 ml – Onomac'ta! LED/UV uyumlu profesyonel formül. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 160,
    image: "/images/products/uno-color-gel.png",
    hoverImage: "/images/products/uno-kalici-oje-kartela-1.webp",
    images: ["/images/products/uno-color-gel.png", "/images/products/uno-kalici-oje-kartela-1.webp", "/images/products/uno-kalici-oje-kartela-2.webp"],
    badge: "yeni",
    category: "Kalıcı Oje",
    inStock: true,
  },
  {
    slug: "uno-rubber-base-coat-15-ml-15ml-ruba",
    name: "Qnail Professional UNO Rubber Base Coat 15 ml",
    description:
      "Qnail Professional UNO Rubber Base Coat 15 ml – Onomac'ta! LED/UV uyumlu profesyonel formül. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 159.9,
    image: "/images/products/rubber-base-coat.png",
    badge: "yeni",
    category: "Kalıcı Oje",
    inStock: true,
  },
  {
    slug: "uno-strong-base-coat-15-ml-15ml-stba",
    name: "Qnail Professional UNO Strong Base Coat 15 ml",
    description:
      "Qnail Professional UNO Strong Base Coat 15 ml – Onomac'ta! LED/UV uyumlu profesyonel formül. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 159.9,
    image: "/images/products/uno-strong.png",
    badge: "yeni",
    category: "Kalıcı Oje",
    inStock: true,
  },
  {
    slug: "uno-super-shine-top-coat-15-ml-15ml-sush",
    name: "Qnail Professional UNO Super Shine Top Coat 15 ml",
    description:
      "Qnail Professional UNO Super Shine Top Coat 15 ml – Onomac'ta! LED/UV uyumlu profesyonel formül. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 159.9,
    image: "/images/products/super-shine-top-coat.png",
    badge: "yeni",
    category: "Kalıcı Oje",
    inStock: true,
  },
  {
    slug: "uno-matte-top-coat-15-ml-15ml-mtte",
    name: "Qnail Professional UNO Matte Top Coat 15 ml",
    description:
      "Qnail Professional UNO Matte Top Coat 15 ml – Onomac'ta! LED/UV uyumlu profesyonel formül. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 165,
    image: "/images/products/matte-top-coat.png",
    badge: "yeni",
    category: "Kalıcı Oje",
    inStock: true,
  },
  {
    slug: "uno-non-acid-primer-15-ml-15ml-nona",
    name: "Qnail Professional UNO Non-Acid Primer 15 ml",
    description:
      "Qnail Professional UNO Non-Acid Primer 15 ml – Onomac'ta! LED/UV uyumlu profesyonel formül. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 159.9,
    image: "/images/products/primer-bond.png",
    badge: "yeni",
    category: "Kalıcı Oje",
    inStock: true,
  },
  {
    slug: "uno-lux-primer-15-ml-15ml-lupr",
    name: "Qnail Professional UNO Lux Primer 15 ml",
    description:
      "Qnail Professional UNO Lux Primer 15 ml – Onomac'ta! LED/UV uyumlu profesyonel formül. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 159.9,
    image: "/images/products/lux-primer.png",
    badge: "yeni",
    category: "Kalıcı Oje",
    inStock: true,
  },
  {
    slug: "uno-lux-top-coat-15-ml-15ml-luto",
    name: "Qnail Professional UNO Lux Top Coat 15 ml",
    description:
      "Qnail Professional UNO Lux Top Coat 15 ml – Onomac'ta! LED/UV uyumlu profesyonel formül. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 159.9,
    image: "/images/products/high-gloss-top-coat.png",
    badge: "yeni",
    category: "Kalıcı Oje",
    inStock: true,
  },
  {
    slug: "uno-super-white-15-ml-15ml-supw",
    name: "Qnail Professional UNO Super White 15 ml",
    description:
      "Qnail Professional UNO Super White 15 ml – Onomac'ta! LED/UV uyumlu profesyonel formül. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 160,
    image: "/images/products/uno-color-gel.png",
    badge: "yeni",
    category: "Kalıcı Oje",
    inStock: true,
  },
  {
    slug: "qnail-blooming-gel-15-ml-15ml-bloom",
    name: "QNAIL Blooming Gel 15 ml",
    description:
      "QNAIL Blooming Gel 15 ml – Onomac'ta! LED/UV uyumlu profesyonel formül. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 171.99,
    image: "/images/products/uno-color-gel.png",
    badge: "yeni",
    category: "Kalıcı Oje",
    inStock: true,
  },
  {
    slug: "uno-super-shine-top-coat-50-ml-50ml-sush",
    name: "Qnail Professional UNO Super Shine Top Coat 50 ml",
    description:
      "Qnail Professional UNO Super Shine Top Coat 50 ml – Onomac'ta! LED/UV uyumlu profesyonel formül. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 335,
    image: "/images/products/super-shine-top-coat-50ml.png",
    badge: "yeni",
    category: "Kalıcı Oje",
    inStock: true,
  },
  {
    slug: "uno-rubber-base-coat-50-ml-50ml-ruba",
    name: "Qnail Professional UNO Rubber Base Coat 50 ml",
    description:
      "Qnail Professional UNO Rubber Base Coat 50 ml – Onomac'ta! LED/UV uyumlu profesyonel formül. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 335,
    image: "/images/products/rubber-base-coat-50ml.png",
    badge: "yeni",
    category: "Kalıcı Oje",
    inStock: true,
  },
  {
    slug: "hamur-jel-clear-15-gr-scgel-01",
    name: "Qnail Professional Hamur Jel Clear 15 gr",
    description:
      "Qnail Professional Hamur Jel Clear 15 gr – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 240,
    image: "/images/products/sculpter-builder-gel-no-1.png",
    hoverImage: "/images/products/sculpter-builder-gel-no-1-kartela.png",
    images: ["/images/products/sculpter-builder-gel-no-1.png", "/images/products/sculpter-builder-gel-no-1-kartela.png"],
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "hamur-jel-nude-15-gr-scgel-03",
    name: "Qnail Professional Hamur Jel Nude 15 gr",
    description:
      "Qnail Professional Hamur Jel Nude 15 gr – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 240,
    image: "/images/products/sculpture.png",
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "hamur-jel-pink-15-gr-scgel-04",
    name: "Qnail Professional Hamur Jel Pink 15 gr",
    description:
      "Qnail Professional Hamur Jel Pink 15 gr – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 240,
    image: "/images/products/sculpter-builder-gel-no-4.png",
    hoverImage: "/images/products/sculpter-builder-gel-no-4-kartela.png",
    images: ["/images/products/sculpter-builder-gel-no-4.png", "/images/products/sculpter-builder-gel-no-4-kartela.png"],
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "uno-poly-gel-30-gr-milkwhite-30-gr-plgl-02",
    name: "Qnail Professional UNO Poly Gel 30G Milkwhite 30G",
    description:
      "Qnail Professional UNO Poly Gel 30 gr Milkwhite 30 gr – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 335,
    image: "/images/products/mixgel-milk-white.png",
    hoverImage: "/images/products/mixgel-milk-white-kartela.png",
    images: ["/images/products/mixgel-milk-white.png", "/images/products/mixgel-milk-white-kartela.png"],
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "uno-poly-gel-30-gr-milkshake-30-gr-plgl-03",
    name: "Qnail Professional UNO Poly Gel 30G Milkshake 30G",
    description:
      "Qnail Professional UNO Poly Gel 30 gr Milkshake 30 gr – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 335,
    image: "/images/products/mixgel-milkshake.png",
    hoverImage: "/images/products/mixgel-milkshake-kartela.png",
    images: ["/images/products/mixgel-milkshake.png", "/images/products/mixgel-milkshake-kartela.png"],
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "uno-poly-gel-30-gr-pink-30-gr-plgl-04",
    name: "Qnail Professional UNO Poly Gel 30G Pink 30G",
    description:
      "Qnail Professional UNO Poly Gel 30 gr Pink 30 gr – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 335,
    image: "/images/products/mixgel-pinksilk.png",
    hoverImage: "/images/products/mixgel-pinksilk-kartela.png",
    images: ["/images/products/mixgel-pinksilk.png", "/images/products/mixgel-pinksilk-kartela.png"],
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "uno-poly-gel-30-gr-nude-30-gr-plgl-05",
    name: "Qnail Professional UNO Poly Gel 30G Nude 30G",
    description:
      "Qnail Professional UNO Poly Gel 30 gr Nude 30 gr – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 335,
    image: "/images/products/mixgel-nude.png",
    hoverImage: "/images/products/mixgel-nude-kartela.png",
    images: ["/images/products/mixgel-nude.png", "/images/products/mixgel-nude-kartela.png"],
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "ombre-jeli-set-1-9-renkli-ombjel-01",
    name: "Qnail Professional Ombre Jeli SET-1 9 Renkli",
    description:
      "Qnail Professional Ombre Jeli SET-1 9 Renkli – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 0.0,
    image: "/images/products/ombre-sungeri-tutucu-kalem.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: false,
  },
  {
    slug: "ombre-jeli-set-2-9-renkli-ombjel-02",
    name: "Qnail Professional Ombre Jeli SET-2 9 Renkli",
    description:
      "Qnail Professional Ombre Jeli SET-2 9 Renkli – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 0.0,
    image: "/images/products/ombre-sungeri-tutucu-kalem.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: false,
  },
  {
    slug: "ombre-jeli-set-3-9-renkli-ombjel-03",
    name: "Qnail Professional Ombre Jeli SET-3 9 Renkli",
    description:
      "Qnail Professional Ombre Jeli SET-3 9 Renkli – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 0.0,
    image: "/images/products/ombre-sungeri-tutucu-kalem.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: false,
  },
  {
    slug: "ombre-jeli-set-4-9-renkli-ombjel-04",
    name: "Qnail Professional Ombre Jeli SET-4 9 Renkli",
    description:
      "Qnail Professional Ombre Jeli SET-4 9 Renkli – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 0.0,
    image: "/images/products/ombre-sungeri-tutucu-kalem.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: false,
  },
  {
    slug: "cleanser-250-ml-cleanser",
    name: "Qnail Professional Cleanser 250 ml",
    description:
      "Qnail Professional Cleanser 250 ml – Onomac'ta! Sağlıklı tırnaklar için evde profesyonel bakım. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 135,
    image: "/images/products/cleanser.png",
    badge: "yeni",
    category: "Tırnak Bakımı",
    inStock: true,
  },
  {
    slug: "gold-metalik-cizim-jeli-5-gr-mtgl-gld",
    name: "Qnail Professional Gold Metalik Çizim Jeli 5g",
    description:
      "Qnail Professional Gold Metalik Çizim Jeli 5 gr – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 165,
    image: "/images/products/uno-color-gel.png",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "silver-metalik-cizim-jeli-5-gr-mtgl-slvr",
    name: "Qnail Professional Silver Metalik Çizim Jeli 5g",
    description:
      "Qnail Professional Silver Metalik Çizim Jeli 5 gr – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 159.99,
    image: "/images/products/uno-color-gel.png",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "kelebek-protez-tirnak-ve-takma-tirnak-sablonu-500-lu-form-bfly",
    name: "Qnail Professional Kelebek Protez Tırnak ve Takma Tırnak Şablonu 500'lü",
    description:
      "Qnail Professional Kelebek Protez Tırnak ve Takma Tırnak Şablonu 500'lu – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 285,
    image: "/images/products/protez/protez-form-sablonu-100.jpg",
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "gold-protez-tirnak-ve-takma-tirnak-sablonu-500-lu-form-gld",
    name: "Qnail Professional Gold Protez Tırnak ve Takma Tırnak Şablonu 500'lu",
    description:
      "Qnail Professional Gold Protez Tırnak ve Takma Tırnak Şablonu 500'lu – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 226.99,
    image: "/images/products/gold-protez-tirnak-takma-sablonu.jpg",
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "mor-balik-protez-tirnak-ve-takma-tirnak-sablonu-500-lu-form-purp",
    name: "Qnail Professional Mor Balık Protez Tırnak ve Takma Tırnak Şablonu 500'lu",
    description:
      "Qnail Professional Mor Balık Protez Tırnak ve Takma Tırnak Şablonu 500'lu – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 327.99,
    image: "/images/products/mor-balik-protez-tirnak-takma-sablonu.jpg",
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "sun-max-uv-led-tirnak-kurutucu-220w-uv-xmax",
    name: "Qnail Professional SUN Max UV LED Tırnak Kurutucu 220 Watt",
    description:
      "Qnail Professional SUN Max UV LED Tırnak Kurutucu 220W – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 485,
    image: "/images/products/sun-max-uv-led-tirnak-kurutucu-220w-uv-xmax.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: true,
  },
  {
    slug: "sun-x-11-uv-led-tirnak-kurutucu-280w-45-66-led-uv-x11",
    name: "Qnail Professional SUN X 11 UV LED Tırnak Kurutucu 280 Watt 45/66 LED",
    description:
      "Qnail Professional SUN X 11 UV LED Tırnak Kurutucu 280W 45/66 LED – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 489.9,
    image: "/images/products/sun-x-11-uv-led-tirnak-kurutucu-280w-45-66-led-uv-x11.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: true,
  },
  {
    slug: "sun-x-15-uv-led-tirnak-kurutucu-280w-66-led-uv-x15",
    name: "Qnail Professional SUN X 15 UV LED Tırnak Kurutucu 280 Watt 66 LED",
    description:
      "Qnail Professional SUN X 15 UV LED Tırnak Kurutucu 280W 66 LED – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 685,
    image: "/images/products/sun-x-15-uv-led-tirnak-kurutucu-280w-66-led-uv-x15.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: false,
  },
  {
    slug: "sun-x-21-uv-led-tirnak-kurutucu-320w-72-led-uv-x21",
    name: "Qnail Professional SUN X 21 UV LED Tırnak Kurutucu 320 Watt 72 LED",
    description:
      "Qnail Professional SUN X 21 UV LED Tırnak Kurutucu 320W 72 LED – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 800,
    image: "/images/products/sun-x-21-uv-led-tirnak-kurutucu-320w-72-led-uv-x21.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: true,
  },
  {
    slug: "sun-x-26-uv-led-tirnak-kurutucu-380w-81-led-uv-x26",
    name: "Qnail Professional SUN X 26 UV LED Tırnak Kurutucu 380W 81 LED",
    description:
      "Qnail Professional SUN X 26 UV LED Tırnak Kurutucu 380W 81 LED – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 850,
    image: "/images/products/sun-x-26-uv-led-tirnak-kurutucu-380w-81-led-uv-x26.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: true,
  },
  {
    slug: "uv-led-kurutucu-akrobat-lamba-siyah-uv-acr",
    name: "Qnail Professional UV LED Kurutucu Akrobat Lamba Siyah",
    description:
      "Qnail Professional UV LED Kurutucu Akrobat Lamba Siyah – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 339.9,
    image: "/images/products/uv-led-kurutucu-akrobat-lamba-siyah-uv-acr.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: false,
  },
  {
    slug: "masa-lambasi-siyah-lamp-1",
    name: "Qnail Professional Masa Lambası Siyah",
    description:
      "Qnail Professional Masa Lambası Siyah – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 936.99,
    image: "/images/products/masa-lambasi-siyah-lamp-1.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: true,
  },
  {
    slug: "dr-pen-a1-drpen-01",
    name: "Qnail Professional DR.PEN A1",
    description:
      "Qnail Professional DR.PEN A1 – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 3510.99,
    image: "/images/products/dr-pen-a1-drpen-01.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: true,
  },
  {
    slug: "3-fanli-toz-toplama-120w-dstcl-3",
    name: "Qnail Professional 3 Fanlı Toz Toplama 120W",
    description:
      "Qnail Professional 3 Fanlı Toz Toplama 120W – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 985,
    image: "/images/products/3-fanli-toz-toplama-120w-dstcl-3.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: true,
  },
  {
    slug: "tek-fanli-toz-toplama-40w-dstcl-1",
    name: "Qnail Professional Tek Fanlı Toz Toplama 40W",
    description:
      "Qnail Professional Tek Fanlı Toz Toplama 40W – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 885,
    image: "/images/products/tek-fanli-toz-toplama-40w-dstcl-1.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: true,
  },
  {
    slug: "sterilize-makinesi-360-derece-strl-360t",
    name: "Qnail Professional Sterilize Makinesi 360 Derece",
    description:
      "Qnail Professional Sterilize Makinesi 360 Derece – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 1889.9,
    image: "/images/products/sterilize-makinesi-360-derece-strl-360t.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: false,
  },
  {
    slug: "elektrikli-manikur-cihazi-mncr-hsz",
    name: "Qnail Professional Elektrikli Manikür Cihazı",
    description:
      "Qnail Professional Elektrikli Manikür Cihazı – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 239.9,
    image: "/images/products/elektrikli-manikur-cihazi-mncr-hsz.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: true,
  },
  {
    slug: "strong-210-mavi-kutu-frz-210bl",
    name: "Qnail Professional Strong 210 Freze Makinesi – Mavi Kutu",
    description:
      "Qnail Professional Strong 210 Freze Makinesi – Mavi Kutu – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 4563.99,
    image: "/images/products/strong-210-mavi-kutu-frz-210bl.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: true,
  },
  {
    slug: "protez-tirnak-manikur-torpu-frez-makinesi-35-000-rpm-frz-af35",
    name: "Qnail Professional Protez Tırnak Manikür Törpü Frez Makinesi 35.000 RPM",
    description:
      "Qnail Professional Protez Tırnak Manikür Törpü Frez Makinesi 35.000 RPM – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 1716.99,
    image: "/images/products/protez-tirnak-manikur-torpu-frez-makinesi-35-000-rpm-frz-af35.jpg",
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "tips-yarim-ay-protez-tirnak-kemik-500-lu-tips-mwh",
    name: "Qnail Professional Tips Yarım Ay Protez Tırnak Kemik 500'lu",
    description:
      "Qnail Professional Tips Yarım Ay Protez Tırnak Kemik 500'lu – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 124.99,
    image: "/images/products/besyuzlu-kemik-yarimay-tips.jpg",
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "tips-yarim-ay-protez-tirnak-seffaf-500-lu-tips-clr",
    name: "Qnail Professional Tips Yarım Ay Protez Tırnak Şeffaf 500 Lü",
    description:
      "Qnail Professional Tips Yarım Ay Protez Tırnak Şeffaf 500'lu – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 160,
    image: "/images/products/besyuzlu-seffaf-yarimay-tips.jpg",
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "tips-yarim-ay-protez-tirnak-beyaz-500-lu-tips-wht",
    name: "Qnail Professional Tips Yarım Ay Protez Tırnak Beyaz 500 Lü",
    description:
      "Qnail Professional Tips Yarım Ay Protez Tırnak Beyaz 500'lu – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 150,
    image: "/images/products/besyuzlu-seffaf-yarimay-tips.jpg",
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: false,
  },
  {
    slug: "ust-form-12-boy-tps-up12",
    name: "Qnail Professional Üst Form 12 Boy",
    description:
      "Qnail Professional Üst Form 12 Boy – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 163.99,
    image: "/images/products/protez/protez-form-sablonu-100.jpg",
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "ust-form-arched-almond-tps-upaa",
    name: "Qnail Professional Üst Form Arched Almond",
    description:
      "Qnail Professional Üst Form Arched Almond – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 187.99,
    image: "/images/products/protez/protez-form-sablonu-100.jpg",
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "sandvic-form-stiletto-sand-stl",
    name: "Qnail Professional Sandviç Form Stiletto",
    description:
      "Qnail Professional Sandviç Form Stiletto – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 312.99,
    image: "/images/products/protez/protez-form-sablonu-100.jpg",
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "sandvic-form-kare-sand-sqr",
    name: "Qnail Professional Sandviç Form Kare",
    description:
      "Qnail Professional Sandviç Form Kare – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 312.99,
    image: "/images/products/protez/protez-form-sablonu-100.jpg",
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "soft-gel-tips-medium-almond-550-li-sftgl-malm",
    name: "Qnail Professional Soft Gel Tips Medium Almond 550'li",
    description:
      "Qnail Professional Soft Gel Tips Medium Almond 550'li – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 240,
    image: "/images/products/medium-almond-soft-gel-tips.jpg",
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "soft-gel-tips-short-stiletto-550-li-sftgl-sstl",
    name: "Qnail Professional Soft Gel Tips Short Stiletto 550'li",
    description:
      "Qnail Professional Soft Gel Tips Short Stiletto 550'li – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 240,
    image: "/images/products/short-stiletto-soft-gel-tips.jpg",
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "soft-gel-tips-french-bamboo-550-li-440-li-sftgl-fbam",
    name: "Qnail Professional Soft Gel Tips French Bamboo 550'li 440'lı",
    description:
      "Qnail Professional Soft Gel Tips French Bamboo 550'li 440'li – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 240,
    image: "/images/products/french-bamboo-soft-gel-tips.jpg",
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "soft-gel-tips-long-coffin-550-li-sftgl-lcof",
    name: "Qnail Professional Soft Gel Tips Long Coffin 550'li",
    description:
      "Qnail Professional Soft Gel Tips Long Coffin 550'li – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 240,
    image: "/images/products/long-coffin-soft-gel-tips.jpg",
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "soft-gel-tips-medium-coffin-550-li-sftgl-mcof",
    name: "Qnail Professional Soft Gel Tips Medium Coffin 550'li",
    description:
      "Qnail Professional Soft Gel Tips Medium Coffin 550'li – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 240,
    image: "/images/products/medium-coffin-soft-gel-tips.jpg",
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "soft-gel-tips-medium-stiletto-550-li-sftgl-mstl",
    name: "Qnail Professional Soft Gel Tips Medium Stiletto 550'li",
    description:
      "Qnail Professional Soft Gel Tips Medium Stiletto 550'li – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 195.99,
    image: "/images/products/medium-stiletto-soft-gel-tips.jpg",
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "kemik-kartela-ters-uc-clcrd-mw",
    name: "Qnail Professional Kemik Kartela Ters Uç",
    description:
      "Qnail Professional Kemik Kartela Ters Uç – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 89.9,
    image: "/images/products/kemik-kartela-ters-uc-clcrd-mw.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: true,
  },
  {
    slug: "kemik-kartela-stiletto-clcrd-mwstl",
    name: "Qnail Professional Kemik Kartela Stiletto",
    description:
      "Qnail Professional Kemik Kartela Stiletto – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 110,
    image: "/images/products/kemik-kartela-stiletto-clcrd-mwstl.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: true,
  },
  {
    slug: "seffaf-kartela-stiletto-clcrd-cstl",
    name: "Qnail Professional Şeffaf Kartela Stiletto",
    description:
      "Qnail Professional Şeffaf Kartela Stiletto – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 70.99,
    image: "/images/products/seffaf-kartela-stiletto-clcrd-cstl.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: true,
  },
  {
    slug: "kemik-kartela-badem-uc-clcrd-mwal",
    name: "Qnail Professional Kemik Kartela Badem Uç",
    description:
      "Qnail Professional Kemik Kartela Badem Uç – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 110,
    image: "/images/products/kemik-kartela-badem-uc-clcrd-mwal.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: true,
  },
  {
    slug: "seffaf-kartela-badem-uc-clcrd-calm",
    name: "Qnail Professional Şeffaf Kartela Badem Uç",
    description:
      "Qnail Professional Şeffaf Kartela Badem Uç – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 105,
    image: "/images/products/seffaf-kartela-badem-uc-clcrd-calm.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: true,
  },
  {
    slug: "metal-torpu-file-stl",
    name: "Qnail Professional Metal Törpü",
    description:
      "Qnail Professional Metal Törpü – Onomac'ta! Sağlıklı tırnaklar için evde profesyonel bakım. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 39.99,
    image: "/images/products/metal-torpu-file-stl.jpg",
    badge: "yeni",
    category: "Tırnak Bakımı",
    inStock: true,
  },
  {
    slug: "tirnak-torpusu-80-100-25-li-file-80100",
    name: "Qnail Professional Tırnak Törpüsü 80/100 25'li",
    description:
      "Qnail Professional Tırnak Törpüsü 80/100 25'li – Onomac'ta! Sağlıklı tırnaklar için evde profesyonel bakım. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 273.99,
    image: "/images/products/kagit-torpu-100-100.jpg",
    badge: "yeni",
    category: "Tırnak Bakımı",
    inStock: true,
  },
  {
    slug: "tirnak-torpusu-100-100-file-100100",
    name: "Qnail Professional Tırnak Törpüsü 100/100",
    description:
      "Qnail Professional Tırnak Törpüsü 100/100 – Onomac'ta! Sağlıklı tırnaklar için evde profesyonel bakım. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 343.99,
    image: "/images/products/kagit-torpu-100-100.jpg",
    badge: "yeni",
    category: "Tırnak Bakımı",
    inStock: true,
  },
  {
    slug: "tirnak-torpusu-100-180-file-100180",
    name: "Qnail Professional Tırnak Törpüsü 100/180",
    description:
      "Qnail Professional Tırnak Törpüsü 100/180 – Onomac'ta! Sağlıklı tırnaklar için evde profesyonel bakım. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 343.99,
    image: "/images/products/kagit-torpu-100-180.jpg",
    badge: "yeni",
    category: "Tırnak Bakımı",
    inStock: true,
  },
  {
    slug: "buffer-torpu-10-lu-100-180-bffr-100180",
    name: "Qnail Professional Buffer Törpü 10'lu 100/180",
    description:
      "Qnail Professional Buffer Törpü 10'lu 100/180 – Onomac'ta! Sağlıklı tırnaklar için evde profesyonel bakım. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 187.99,
    image: "/images/products/buffer-torpu-100-180.jpg",
    hoverImage: "/images/products/buffer-torpu-100-180-1.jpg",
    images: [
      "/images/products/buffer-torpu-100-180.jpg",
      "/images/products/buffer-torpu-100-180-1.jpg",
      "/images/products/buffer-torpu-100-180-2.jpg",
      "/images/products/buffer-torpu-100-180-3.jpg",
    ],
    badge: "yeni",
    category: "Tırnak Bakımı",
    inStock: true,
  },
  {
    slug: "kronk-krnk-1",
    name: "Qnail Professional Kronk",
    description:
      "Qnail Professional Kronk – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 31.99,
    image: "/images/products/kronk-krnk-1.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: true,
  },
  {
    slug: "metal-tips-makasi-scs-stl",
    name: "Qnail Professional Metal Tips Makası",
    description:
      "Qnail Professional Metal Tips Makası – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 155,
    image: "/images/products/tips-makasi.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: true,
  },
  {
    slug: "plastik-tips-makasi-scs-pls",
    name: "Qnail Professional Plastik Tips Makası",
    description:
      "Qnail Professional Plastik Tips Makası – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 89.9,
    image: "/images/products/tips-makasi.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: true,
  },
  {
    slug: "profesyonel-manikur-seti-mncr-set",
    name: "Qnail Professional Profesyonel Manikür Seti",
    description:
      "Qnail Professional Profesyonel Manikür Seti – Onomac'ta! Sağlıklı tırnaklar için evde profesyonel bakım. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 702.99,
    image: "/images/products/profesyonel-manikur-seti.png",
    badge: "yeni",
    category: "Tırnak Bakımı",
    inStock: true,
  },
  {
    slug: "tuysuz-mendil-540-li-pol-rmvr",
    name: "Qnail Professional Tüysüz Mendil 540'li",
    description:
      "Qnail Professional Tüysüz Mendil 540'li – Onomac'ta! Sağlıklı tırnaklar için evde profesyonel bakım. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 62.99,
    image: "/images/products/540-adet-manikur-temizleme-mendili.jpg",
    badge: "yeni",
    category: "Tırnak Bakımı",
    inStock: true,
  },
  {
    slug: "pembe-tuysuz-mendil-kutulu-200-lu-bxpol-rmvr",
    name: "Qnail Professional Pembe Tüysüz Mendil Kutulu 200'lü",
    description:
      "Qnail Professional Pembe Tüysüz Mendil Kutulu 200'lu – Onomac'ta! Sağlıklı tırnaklar için evde profesyonel bakım. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 89.9,
    image: "/images/products/540-adet-manikur-temizleme-mendili.jpg",
    badge: "yeni",
    category: "Tırnak Bakımı",
    inStock: true,
  },
  {
    slug: "tekli-miknatis-mgnt-ce",
    name: "Qnail Professional Tekli Mıknatıs",
    description:
      "Qnail Professional Tekli Mıknatıs – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 54.99,
    image: "/images/products/ikili-cat-eye-miknatis.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "5-li-miknatis-mgnt-5n1",
    name: "Qnail Professional 5'li Mıknatıs",
    description:
      "Qnail Professional 5'li Mıknatıs – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 156.99,
    image: "/images/products/cat-eye-magnet.png",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "9-lu-miknatis-mgnt-9n1",
    name: "Qnail Professional 9'lu Mıknatıs",
    description:
      "Qnail Professional 9'lu Mıknatıs – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 218.99,
    image: "/images/products/cat-eye-magnet.png",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "kutulu-ombre-sungeri-ombr-spng",
    name: "Qnail Professional Kutulu Ombre Süngeri",
    description:
      "Qnail Professional Kutulu Ombre Süngeri – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 159.9,
    image: "/images/products/ombre-sungeri-tutucu-kalem.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "portakal-cubugu-100-lu-pstck",
    name: "Qnail Professional Portakal Çubuğu 100'lü",
    description:
      "Qnail Professional Portakal Çubuğu 100'lu – Onomac'ta! Sağlıklı tırnaklar için evde profesyonel bakım. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 89.9,
    image: "/images/products/portakal-cubugu-100-lu-pstck.jpg",
    badge: "yeni",
    category: "Tırnak Bakımı",
    inStock: true,
  },
  {
    slug: "tirnak-recine-tasi-qa-899",
    name: "Qnail Professional Tırnak Reçine Taşı",
    description:
      "Qnail Professional Tırnak Reçine Taşı – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 132.99,
    image: "/images/products/tirnak-recine-tasi-qa-899.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "kalpli-tirnak-recine-tasi-qa-901",
    name: "Qnail Professional Kalpli Tırnak Reçine Taşı",
    description:
      "Qnail Professional Kalpli Tırnak Reçine Taşı – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 0.0,
    image: "/images/products/kalpli-tirnak-recine-tasi-qa-901.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: false,
  },
  {
    slug: "kapakli-tirnak-fondoten-fircasi-5-renk-mavi-pembe-gold-rose-silver-brsh-kf",
    name: "Qnail Professional Kapaklı Tırnak & Fondoten Fırçası 5 Renk Mavi & Pembe & Gold Rose & Silver",
    description:
      "Qnail Professional Kapaklı Tırnak & Fondoten Fırçası 5 Renk Mavi & Pembe & Gold Rose & Silver – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 148.99,
    image: "/images/products/inci-tozu-fircasi.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: true,
  },
  {
    slug: "toz-firca-brsh-dst",
    name: "Qnail Professional Toz Fırça",
    description:
      "Qnail Professional Toz Fırça – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 0.0,
    image: "/images/products/inci-tozu-fircasi.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: false,
  },
  {
    slug: "8-li-full-firca-set-brush-8n1",
    name: "Qnail Professional 8'li Full Fırça Set",
    description:
      "Qnail Professional 8'li Full Fırça Set – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 165.9,
    image: "/images/products/sekizli-renkli-nailart-fircasi.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: true,
  },
  {
    slug: "9-lu-firca-seti-gri-brsh-07",
    name: "Qnail Professional 9'lu Fırça Seti Gri",
    description:
      "Qnail Professional 9'lu Fırça Seti Gri – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 0.0,
    image: "/images/products/dokuzlu-nailart-fircasi.jpg",
    hoverImage: "/images/products/dokuzlu-nailart-fircasi-seti.jpg",
    images: ["/images/products/dokuzlu-nailart-fircasi.jpg", "/images/products/dokuzlu-nailart-fircasi-seti.jpg"],
    badge: "yeni",
    category: "Aksesuar",
    inStock: false,
  },
  {
    slug: "9-lu-firca-seti-kahverengi-brsh-08",
    name: "Qnail Professional 9'lu Fırça Seti Kahverengi",
    description:
      "Qnail Professional 9'lu Fırça Seti Kahverengi – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 156.99,
    image: "/images/products/dokuzlu-nailart-fircasi-seti.jpg",
    hoverImage: "/images/products/dokuzlu-nailart-fircasi.jpg",
    images: ["/images/products/dokuzlu-nailart-fircasi-seti.jpg", "/images/products/dokuzlu-nailart-fircasi.jpg"],
    badge: "yeni",
    category: "Aksesuar",
    inStock: true,
  },
  {
    slug: "5-li-silikon-firca-brsh-05",
    name: "Qnail Professional 5'li Silikon Fırça",
    description:
      "Qnail Professional 5'li Silikon Fırça – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 117.99,
    image: "/images/products/uclu-nailart-fircasi.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "3-lu-nail-art-firca-set-brshna-3",
    name: "Qnail Professional 3'lü Nail Art Fırça Set",
    description:
      "Qnail Professional 3'lu Nail Art Fırça Set – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 185,
    image: "/images/products/uclu-nailart-fircasi.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "3-lu-jel-firca-set-brshsg-3",
    name: "Qnail Professional 3'lu Jel Fırça Set",
    description:
      "Qnail Professional 3'lu Jel Fırça Set – Onomac'ta! Salon kalitesinde protez uygulaması için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 120,
    image: "/images/products/uclu-gel-fircasi.jpg",
    hoverImage: "/images/products/jel-firca-seti.jpg",
    images: ["/images/products/uclu-gel-fircasi.jpg", "/images/products/jel-firca-seti.jpg"],
    badge: "yeni",
    category: "Protez Tırnak",
    inStock: true,
  },
  {
    slug: "3-lu-cift-uclu-jel-ve-nail-art-cizim-fircasi-seti-brshng-3",
    name: "Qnail Professional 3’lu Çift Uçlu Jel ve Nail Art Çizim Fırçası Seti",
    description:
      "Qnail Professional 3’lu Çift Uçlu Jel ve Nail Art Çizim Fırçası Seti – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 185,
    image: "/images/products/uclu-cizim-fircasi.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "lipstick-firca-brsh-lps",
    name: "Qnail Professional Lipstick Fırça",
    description:
      "Qnail Professional Lipstick Fırça – Onomac'ta! Profesyonel uygulama için olmazsa olmaz yardımcı. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 62.99,
    image: "/images/products/uclu-cizim-fircasi.jpg",
    badge: "yeni",
    category: "Aksesuar",
    inStock: true,
  },
  {
    slug: "neon-tozu-neon-dst12",
    name: "Qnail Professional Neon Tozu",
    description:
      "Qnail Professional Neon Tozu – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 187.99,
    image: "/images/products/inci-tozu-altili.jpg",
    hoverImage: "/images/products/inci-tozu-altili-kartela.jpg",
    images: ["/images/products/inci-tozu-altili.jpg", "/images/products/inci-tozu-altili-kartela.jpg"],
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "kutulu-6-li-inci-tozu-pwdr6-whtbx",
    name: "Qnail Professional Kutulu 6'lı İnci Tozu",
    description:
      "Qnail Professional Kutulu 6'li İnci Tozu – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 169.9,
    image: "/images/products/beyaz-inci-tozu-altili-kartela.jpg",
    hoverImage: "/images/products/beyaz-inci-tozu-altili.jpg",
    images: ["/images/products/beyaz-inci-tozu-altili-kartela.jpg", "/images/products/beyaz-inci-tozu-altili.jpg"],
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "kutulu-6-li-krom-tozu-renkli-pwdr6-cl1bx",
    name: "Qnail Professional Kutulu 6'lı Krom Tozu Renkli",
    description:
      "Qnail Professional Kutulu 6'li Krom Tozu Renkli – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 165,
    image: "/images/products/renkli-inci-tozu-altili-kartela.jpg",
    hoverImage: "/images/products/renkli-inci-tozu-altili.jpg",
    images: ["/images/products/renkli-inci-tozu-altili-kartela.jpg", "/images/products/renkli-inci-tozu-altili.jpg"],
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "6-li-inci-tozu-pwdr6-whtbg",
    name: "Qnail Professional 6'lı İnci Tozu",
    description:
      "Qnail Professional 6'li İnci Tozu – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 169.9,
    image: "/images/products/beyaz-inci-tozu-altili.jpg",
    hoverImage: "/images/products/beyaz-inci-tozu-altili-kartela.jpg",
    images: ["/images/products/beyaz-inci-tozu-altili.jpg", "/images/products/beyaz-inci-tozu-altili-kartela.jpg"],
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "6-li-krom-tozu-renkli-pwdr6-cl1bg",
    name: "Qnail Professional 6'li Krom Tozu Renkli",
    description:
      "Qnail Professional 6'li Krom Tozu Renkli – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 124.99,
    image: "/images/products/renkli-inci-tozu-altili.jpg",
    hoverImage: "/images/products/renkli-inci-tozu-altili-kartela.jpg",
    images: ["/images/products/renkli-inci-tozu-altili.jpg", "/images/products/renkli-inci-tozu-altili-kartela.jpg"],
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "tekli-krom-tozu-silver-pwdr-silver",
    name: "Qnail Professional Tekli Krom Tozu Silver",
    description:
      "Qnail Professional Tekli Krom Tozu Silver – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 54.99,
    image: "/images/products/renkli-inci-tozu-altili.jpg",
    hoverImage: "/images/products/renkli-inci-tozu-altili-kartela.jpg",
    images: ["/images/products/renkli-inci-tozu-altili.jpg", "/images/products/renkli-inci-tozu-altili-kartela.jpg"],
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "tekli-krom-tozu-gold-pwdr-gold",
    name: "Qnail Professional Tekli Krom Tozu Gold",
    description:
      "Qnail Professional Tekli Krom Tozu Gold – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 54.99,
    image: "/images/products/renkli-inci-tozu-altili.jpg",
    hoverImage: "/images/products/renkli-inci-tozu-altili-kartela.jpg",
    images: ["/images/products/renkli-inci-tozu-altili.jpg", "/images/products/renkli-inci-tozu-altili-kartela.jpg"],
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "tekli-krom-tozu-kirmizi-pwdr-red",
    name: "Qnail Professional Tekli Krom Tozu Kırmızı",
    description:
      "Qnail Professional Tekli Krom Tozu Kırmızı – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 54.99,
    image: "/images/products/renkli-inci-tozu-altili.jpg",
    hoverImage: "/images/products/renkli-inci-tozu-altili-kartela.jpg",
    images: ["/images/products/renkli-inci-tozu-altili.jpg", "/images/products/renkli-inci-tozu-altili-kartela.jpg"],
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "tekli-krom-tozu-mavi-pwdr-blue",
    name: "Qnail Professional Tekli Krom Tozu Mavi",
    description:
      "Qnail Professional Tekli Krom Tozu Mavi – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 54.99,
    image: "/images/products/renkli-inci-tozu-altili.jpg",
    hoverImage: "/images/products/renkli-inci-tozu-altili-kartela.jpg",
    images: ["/images/products/renkli-inci-tozu-altili.jpg", "/images/products/renkli-inci-tozu-altili-kartela.jpg"],
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "tekli-krom-tozu-yesil-pwdr-green",
    name: "Qnail Professional Tekli Krom Tozu Yeşil",
    description:
      "Qnail Professional Tekli Krom Tozu Yeşil – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 54.99,
    image: "/images/products/renkli-inci-tozu-altili.jpg",
    hoverImage: "/images/products/renkli-inci-tozu-altili-kartela.jpg",
    images: ["/images/products/renkli-inci-tozu-altili.jpg", "/images/products/renkli-inci-tozu-altili-kartela.jpg"],
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "tekli-krom-tozu-pembe-pwdr-pink1",
    name: "Qnail Professional Tekli Krom Tozu Pembe",
    description:
      "Qnail Professional Tekli Krom Tozu Pembe – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 54.99,
    image: "/images/products/renkli-inci-tozu-altili.jpg",
    hoverImage: "/images/products/renkli-inci-tozu-altili-kartela.jpg",
    images: ["/images/products/renkli-inci-tozu-altili.jpg", "/images/products/renkli-inci-tozu-altili-kartela.jpg"],
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "4-lu-krom-tozu-pwdr4-gsbg",
    name: "Qnail Professional 4'lu Krom Tozu",
    description:
      "Qnail Professional 4'lu Krom Tozu – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 132.99,
    image: "/images/products/koyu-renkli-inci-tozu-altili.jpg",
    hoverImage: "/images/products/koyu-renkli-inci-tozu-altili-kartela.jpg",
    images: ["/images/products/koyu-renkli-inci-tozu-altili.jpg", "/images/products/koyu-renkli-inci-tozu-altili-kartela.jpg"],
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "12-li-havyar-sus-4-renk-qa-cav12",
    name: "Qnail Professional 12'li Havyar Süs 4 Renk",
    description:
      "Qnail Professional 12'li Havyar Süs 4 Renk – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 170,
    image: "/images/products/onikili-karma-havyar-sus.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "6-li-havyar-sus-silver-gold-qa-cav06",
    name: "Qnail Professional 6'li Havyar Süs Silver & Gold",
    description:
      "Qnail Professional 6'li Havyar Süs Silver & Gold – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 85.99,
    image: "/images/products/altili-yuvarlak-havyar-sus.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "6-li-havyar-sus-gold-qagld-cav06",
    name: "Qnail Professional 6'li Havyar Süs Gold",
    description:
      "Qnail Professional 6'li Havyar Süs Gold – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 85.99,
    image: "/images/products/altili-dikdortgen-havyar-sus.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "elmas-tirnak-susu-gold-qa-dgld",
    name: "Qnail Professional Elmas Tırnak Süsü Gold",
    description:
      "Qnail Professional Elmas Tırnak Süsü Gold – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 85.99,
    image: "/images/products/altili-dikdortgen-havyar-sus.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "elmas-tirnak-susu-silver-qa-dslvr",
    name: "Qnail Professional Elmas Tırnak Süsü Silver",
    description:
      "Qnail Professional Elmas Tırnak Süsü Silver – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 85.99,
    image: "/images/products/altili-yuvarlak-havyar-sus.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "12-li-nail-aksesuar-qa-101-qa-101",
    name: "Qnail Professional 12'li Nail Aksesuar QA-101",
    description:
      "Qnail Professional 12'li Nail Aksesuar QA-101 – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 150,
    image: "/images/products/onikili-ay-yildiz-nail-aksesuar.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "12-li-nail-aksesuar-qa-102-qa-102",
    name: "Qnail Professional 12'li Nail Aksesuar QA-102",
    description:
      "Qnail Professional 12'li Nail Aksesuar QA-102 – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 150,
    image: "/images/products/onikili-bronz-boncuk-seti.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "12-li-nail-aksesuar-qa-103-qa-103",
    name: "Qnail Professional 12'li Nail Aksesuar QA-103",
    description:
      "Qnail Professional 12'li Nail Aksesuar QA-103 – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 150,
    image: "/images/products/onikili-fiyonk-kalp-nail-aksesuar.jpg",
    hoverImage: "/images/products/onikili-fiyonk-kalp-nail-aksesuar-kartela.jpg",
    images: ["/images/products/onikili-fiyonk-kalp-nail-aksesuar.jpg", "/images/products/onikili-fiyonk-kalp-nail-aksesuar-kartela.jpg"],
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "12-li-nail-aksesuar-qa-104-qa-104",
    name: "Qnail Professional 12'li Nail Aksesuar QA-104",
    description:
      "Qnail Professional 12'li Nail Aksesuar QA-104 – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 85.99,
    image: "/images/products/onikili-gul-nail-aksesuar.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "12-li-nail-aksesuar-qa-105-qa-105",
    name: "Qnail Professional 12'li Nail Aksesuar QA-105",
    description:
      "Qnail Professional 12'li Nail Aksesuar QA-105 – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 85.99,
    image: "/images/products/onikili-gumus-boncuk-seti.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "nail-aksesuar-qa-106-qa-106",
    name: "Qnail Professional Nail Aksesuar QA-106",
    description:
      "Qnail Professional Nail Aksesuar QA-106 – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 85.99,
    image: "/images/products/onikili-seffaf-fiyonk-kalp-nail-aksesuar.jpg",
    hoverImage: "/images/products/onikili-seffaf-fiyonk-kalp-nail-aksesuar-kartela.jpg",
    images: ["/images/products/onikili-seffaf-fiyonk-kalp-nail-aksesuar.jpg", "/images/products/onikili-seffaf-fiyonk-kalp-nail-aksesuar-kartela.jpg"],
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "nail-aksesuar-qa-107-qa-107",
    name: "Qnail Professional Nail Aksesuar QA-107",
    description:
      "Qnail Professional Nail Aksesuar QA-107 – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 85.99,
    image: "/images/products/onikili-ay-yildiz-nail-aksesuar.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "nail-aksesuar-qa-108-qa-108",
    name: "Qnail Professional Nail Aksesuar QA-108",
    description:
      "Qnail Professional Nail Aksesuar QA-108 – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 85.99,
    image: "/images/products/onikili-bronz-boncuk-seti.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "buyuk-24-lu-nail-aksesuar-qa-301-qa-301",
    name: "Qnail Professional Büyük 24'lu Nail Aksesuar QA-301",
    description:
      "Qnail Professional Büyük 24'lu Nail Aksesuar QA-301 – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 239.9,
    image: "/images/products/onikili-fiyonk-kalp-nail-aksesuar.jpg",
    hoverImage: "/images/products/onikili-fiyonk-kalp-nail-aksesuar-kartela.jpg",
    images: ["/images/products/onikili-fiyonk-kalp-nail-aksesuar.jpg", "/images/products/onikili-fiyonk-kalp-nail-aksesuar-kartela.jpg"],
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "buyuk-24-lu-nail-aksesuar-qa-302-qa-302",
    name: "Qnail Professional Büyük 24'lu Nail Aksesuar QA-302",
    description:
      "Qnail Professional Büyük 24'lu Nail Aksesuar QA-302 – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 275.9,
    image: "/images/products/onikili-gul-nail-aksesuar.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: false,
  },
  {
    slug: "buyuk-24-lu-nail-aksesuar-qa-303-qa-303",
    name: "Qnail Professional Büyük 24'lu Nail Aksesuar QA-303",
    description:
      "Qnail Professional Büyük 24'lu Nail Aksesuar QA-303 – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 335,
    image: "/images/products/onikili-gumus-boncuk-seti.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: false,
  },
  {
    slug: "buyuk-12-li-nail-aksesuar-qa-201-qa-201",
    name: "Qnail Professional Büyük 12'li Nail Aksesuar QA-201",
    description:
      "Qnail Professional Büyük 12'li Nail Aksesuar QA-201 – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 160,
    image: "/images/products/onikili-seffaf-fiyonk-kalp-nail-aksesuar.jpg",
    hoverImage: "/images/products/onikili-seffaf-fiyonk-kalp-nail-aksesuar-kartela.jpg",
    images: ["/images/products/onikili-seffaf-fiyonk-kalp-nail-aksesuar.jpg", "/images/products/onikili-seffaf-fiyonk-kalp-nail-aksesuar-kartela.jpg"],
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "buyuk-12-li-nail-aksesuar-qa-202-qa-202",
    name: "Qnail Professional Büyük 12'li Nail Aksesuar QA-202",
    description:
      "Qnail Professional Büyük 12'li Nail Aksesuar QA-202 – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 160,
    image: "/images/products/onikili-ay-yildiz-nail-aksesuar.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "buyuk-12-li-nail-aksesuar-qa-203-qa-203",
    name: "Qnail Professional Büyük 12'li Nail Aksesuar QA-203",
    description:
      "Qnail Professional Büyük 12'li Nail Aksesuar QA-203 – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 160,
    image: "/images/products/onikili-bronz-boncuk-seti.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "buyuk-12-li-nail-aksesuar-qa-204-qa-204",
    name: "Qnail Professional Büyük 12'li Nail Aksesuar QA-204",
    description:
      "Qnail Professional Büyük 12'li Nail Aksesuar QA-204 – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 160,
    image: "/images/products/onikili-fiyonk-kalp-nail-aksesuar.jpg",
    hoverImage: "/images/products/onikili-fiyonk-kalp-nail-aksesuar-kartela.jpg",
    images: ["/images/products/onikili-fiyonk-kalp-nail-aksesuar.jpg", "/images/products/onikili-fiyonk-kalp-nail-aksesuar-kartela.jpg"],
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "buyuk-12-li-nail-aksesuar-qa-205-qa-205",
    name: "Qnail Professional Büyük 12'li Nail Aksesuar QA-205",
    description:
      "Qnail Professional Büyük 12'li Nail Aksesuar QA-205 – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 160,
    image: "/images/products/onikili-gul-nail-aksesuar.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "buyuk-12-li-nail-aksesuar-qa-206-qa-206",
    name: "Qnail Professional Büyük 12'li Nail Aksesuar QA-206",
    description:
      "Qnail Professional Büyük 12'li Nail Aksesuar QA-206 – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 160,
    image: "/images/products/onikili-gumus-boncuk-seti.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "buyuk-12-li-nail-aksesuar-qa-207-qa-207",
    name: "Qnail Professional Büyük 12'li Nail Aksesuar QA-207",
    description:
      "Qnail Professional Büyük 12'li Nail Aksesuar QA-207 – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 160,
    image: "/images/products/onikili-seffaf-fiyonk-kalp-nail-aksesuar.jpg",
    hoverImage: "/images/products/onikili-seffaf-fiyonk-kalp-nail-aksesuar-kartela.jpg",
    images: ["/images/products/onikili-seffaf-fiyonk-kalp-nail-aksesuar.jpg", "/images/products/onikili-seffaf-fiyonk-kalp-nail-aksesuar-kartela.jpg"],
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "buyuk-12-li-nail-aksesuar-qa-208-qa-208",
    name: "Qnail Professional Büyük 12'li Nail Aksesuar QA-208",
    description:
      "Qnail Professional Büyük 12'li Nail Aksesuar QA-208 – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 160,
    image: "/images/products/onikili-karma-havyar-sus.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "buyuk-12-li-nail-aksesuar-qa-209-qa-209",
    name: "Qnail Professional Büyük 12'li Nail Aksesuar QA-209",
    description:
      "Qnail Professional Büyük 12'li Nail Aksesuar QA-209 – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 171.99,
    image: "/images/products/onikili-ay-yildiz-nail-aksesuar.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "buyuk-12-li-nail-aksesuar-qa-211-qa-211",
    name: "Qnail Professional Büyük 12'li Nail Aksesuar QA-211",
    description:
      "Qnail Professional Büyük 12'li Nail Aksesuar QA-211 – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 171.99,
    image: "/images/products/onikili-bronz-boncuk-seti.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "buyuk-12-li-nail-aksesuar-qa-212-qa-212",
    name: "Qnail Professional Büyük 12'li Nail Aksesuar QA-212",
    description:
      "Qnail Professional Büyük 12'li Nail Aksesuar QA-212 – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 171.99,
    image: "/images/products/onikili-gul-nail-aksesuar.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "buyuk-nail-aksesuar-qa-213-qa-213",
    name: "Qnail Professional Büyük Nail Aksesuar QA-213",
    description:
      "Qnail Professional Büyük Nail Aksesuar QA-213 – Onomac'ta! Evde salon efektli tırnak sanatı için. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen sipariş verin.",
    price: 171.99,
    image: "/images/products/onikili-gumus-boncuk-seti.jpg",
    badge: "yeni",
    category: "Nail Art",
    inStock: true,
  },
  {
    slug: "nagaraku-classic-kirpik-0-07c-9mm-10mm-11mm-12mm-13mm-14mm-15mm-mix-lshcl07c",
    name: "Qnail Professional NAGARAKU Classic Kirpik 0.07C (9mm-10mm- 11mm-12mm-13mm-14mm-... 15mm-Mix)",
    description:
      "Qnail Professional NAGARAKU Classic Kirpik 0.07C (9mm-10mm- 11mm-12mm-13mm-14mm-... 15mm-Mix) – Onomac'ta! Etkileyici bakışlar için profesyonel kirpik ürünleri. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 147.99,
    image: "/images/products/nagaraku-classic-kirpik-0-07c-9mm-10mm-11mm-12mm-13mm-14mm-15mm-mix-lshcl07c.jpg",
    badge: "yeni",
    category: "Kirpik",
    inStock: true,
  },
  {
    slug: "nagaraku-classic-kirpik-0-07d-9mm-10mm-11mm-12mm-13mm-14mm-15mm-mix-lshcl07d",
    name: "Qnail Professional NAGARAKU Classic Kirpik 0.07D (9mm-10mm- 11mm-12mm-13mm-14mm-... 15mm-Mix)",
    description:
      "Qnail Professional NAGARAKU Classic Kirpik 0.07D (9mm-10mm- 11mm-12mm-13mm-14mm-... 15mm-Mix) – Onomac'ta! Etkileyici bakışlar için profesyonel kirpik ürünleri. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 147.99,
    image: "/images/products/nagaraku-classic-kirpik-0-07d-9mm-10mm-11mm-12mm-13mm-14mm-15mm-mix-lshcl07d.jpg",
    badge: "yeni",
    category: "Kirpik",
    inStock: true,
  },
  {
    slug: "nagaraku-cek-birak-kirpik-0-07c-8mm-9mm-10mm-11mm-12mm-13mm-14mm-15mm-mix-lshauf07c",
    name: "Qnail Professional NAGARAKU Çek Bırak Kirpik 0.07C (8mm-9mm- 10mm-11mm-12mm-13mm-... 14mm-15mm-Mix)",
    description:
      "Qnail Professional NAGARAKU Çek Bırak Kirpik 0.07C (8mm-9mm- 10mm-11mm-12mm-13mm-... 14mm-15mm-Mix) – Onomac'ta! Etkileyici bakışlar için profesyonel kirpik ürünleri. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 217.99,
    image: "/images/products/nagaraku-cek-birak-kirpik-0-07c-8mm-9mm-10mm-11mm-12mm-13mm-14mm-15mm-mix-lshauf07c.jpg",
    badge: "yeni",
    category: "Kirpik",
    inStock: true,
  },
  {
    slug: "nagaraku-cek-birak-kirpik-0-07d-8mm-9mm-10mm-11mm-12mm-13mm-14mm-15mm-mix-lshauf07d",
    name: "Qnail Professional NAGARAKU Çek Bırak Kirpik 0.07D (8mm-9mm- 10mm-11mm-12mm-13mm-... 14mm-15mm-Mix)",
    description:
      "Qnail Professional NAGARAKU Çek Bırak Kirpik 0.07D (8mm-9mm- 10mm-11mm-12mm-13mm-... 14mm-15mm-Mix) – Onomac'ta! Etkileyici bakışlar için profesyonel kirpik ürünleri. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 217.99,
    image: "/images/products/nagaraku-cek-birak-kirpik-0-07d-8mm-9mm-10mm-11mm-12mm-13mm-14mm-15mm-mix-lshauf07d.jpg",
    badge: "yeni",
    category: "Kirpik",
    inStock: true,
  },
  {
    slug: "ib-kirpik-yapistirici-yesil-lshgl-gr",
    name: "Qnail Professional IB Kirpik Yapıştırıcı Yeşil",
    description:
      "Qnail Professional IB Kirpik Yapıştırıcı Yeşil – Onomac'ta! Etkileyici bakışlar için profesyonel kirpik ürünleri. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 156.99,
    image: "/images/products/ib-kirpik-yapistirici-yesil-lshgl-gr.jpg",
    badge: "yeni",
    category: "Kirpik",
    inStock: true,
  },
  {
    slug: "ib-kirpik-yapistirici-kirmizi-lshgl-re",
    name: "Qnail Professional IB Kirpik Yapıştırıcı Kırmızı",
    description:
      "Qnail Professional IB Kirpik Yapıştırıcı Kırmızı – Onomac'ta! Etkileyici bakışlar için profesyonel kirpik ürünleri. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 156.99,
    image: "/images/products/ib-kirpik-yapistirici-kirmizi-lshgl-re.jpg",
    badge: "yeni",
    category: "Kirpik",
    inStock: true,
  },
  {
    slug: "qlash-kirpik-lifting-set-liftingset-1",
    name: "Qnail Professional QLASH Kirpik Lifting Set",
    description:
      "Qnail Professional QLASH Kirpik Lifting Set – Onomac'ta! Etkileyici bakışlar için profesyonel kirpik ürünleri. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 445,
    image: "/images/products/qlash-kirpik-lifting-set-liftingset-1.jpg",
    badge: "yeni",
    category: "Kirpik",
    inStock: true,
  },
  {
    slug: "iconsign-kirpik-lifting-set-liftingset-2",
    name: "Qnail Professional ICONSIGN Kirpik Lifting Set",
    description:
      "Qnail Professional ICONSIGN Kirpik Lifting Set – Onomac'ta! Etkileyici bakışlar için profesyonel kirpik ürünleri. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 389.9,
    image: "/images/products/iconsign-kirpik-lifting-set-liftingset-2.jpg",
    badge: "yeni",
    category: "Kirpik",
    inStock: true,
  },
  {
    slug: "kas-kirpik-fircasi-50-li-brsh-lsh",
    name: "Qnail Professional Kaş-Kirpik Fırçası 50'li",
    description:
      "Qnail Professional Kaş-Kirpik Fırçası 50'li – Onomac'ta! Etkileyici bakışlar için profesyonel kirpik ürünleri. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 109.9,
    image: "/images/products/sekizli-renkli-nailart-fircasi.jpg",
    badge: "yeni",
    category: "Kirpik",
    inStock: true,
  },
  {
    slug: "goz-alti-pedi-50-li-eyepd-01",
    name: "Qnail Professional Göz Altı Pedi 50'li",
    description:
      "Qnail Professional Göz Altı Pedi 50'li – Onomac'ta! Etkileyici bakışlar için profesyonel kirpik ürünleri. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 187.99,
    image: "/images/products/goz-alti-pedi-50-li-eyepd-01.jpg",
    badge: "yeni",
    category: "Kirpik",
    inStock: true,
  },
  {
    slug: "goz-bandi-eyebnd-01",
    name: "Qnail Professional Göz Bandı",
    description:
      "Qnail Professional Göz Bandı – Onomac'ta! Etkileyici bakışlar için profesyonel kirpik ürünleri. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 39.9,
    image: "/images/products/goz-bandi-eyebnd-01.jpg",
    badge: "yeni",
    category: "Kirpik",
    inStock: true,
  },
  {
    slug: "ipek-kirpik-cimbizi-a1-twzr-a1",
    name: "Qnail Professional İpek Kirpik Cımbızı A1",
    description:
      "Qnail Professional İpek Kirpik Cımbızı A1 – Onomac'ta! Etkileyici bakışlar için profesyonel kirpik ürünleri. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 109.9,
    image: "/images/products/ipek-kirpik-cimbizi-a1-twzr-a1.jpg",
    badge: "yeni",
    category: "Kirpik",
    inStock: true,
  },
  {
    slug: "ipek-kirpik-cimbizi-a2-twzr-a2",
    name: "Qnail Professional İpek Kirpik Cımbızı A2",
    description:
      "Qnail Professional İpek Kirpik Cımbızı A2 – Onomac'ta! Etkileyici bakışlar için profesyonel kirpik ürünleri. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 85.99,
    image: "/images/products/protez/protez-frez-uc-seti.jpg",
    hoverImage: "/images/products/protez/protez-frez-uc-seti-hover.jpg",
    images: ["/images/products/protez/protez-frez-uc-seti.jpg", "/images/products/protez/protez-frez-uc-seti-hover.jpg"],
    badge: "yeni",
    category: "Kirpik",
    inStock: true,
  },
  {
    slug: "ipek-kirpik-cimbizi-a3-twzr-a3",
    name: "Qnail Professional İpek Kirpik Cımbızı A3",
    description:
      "Qnail Professional İpek Kirpik Cımbızı A3 – Onomac'ta! Etkileyici bakışlar için profesyonel kirpik ürünleri. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 109.9,
    image: "/images/products/ipek-kirpik-cimbizi-a3-twzr-a3.jpg",
    badge: "yeni",
    category: "Kirpik",
    inStock: true,
  },
  {
    slug: "ipek-kirpik-cimbizi-a4-twzr-a4",
    name: "Qnail Professional İpek Kirpik Cımbızı A4",
    description:
      "Qnail Professional İpek Kirpik Cımbızı A4 – Onomac'ta! Etkileyici bakışlar için profesyonel kirpik ürünleri. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 109.9,
    image: "/images/products/protez/protez-frez-uc-seti.jpg",
    hoverImage: "/images/products/protez/protez-frez-uc-seti-hover.jpg",
    images: ["/images/products/protez/protez-frez-uc-seti.jpg", "/images/products/protez/protez-frez-uc-seti-hover.jpg"],
    badge: "yeni",
    category: "Kirpik",
    inStock: true,
  },
  {
    slug: "ipek-kirpik-cimbizi-a5-twzr-a5",
    name: "Qnail Professional İpek Kirpik Cımbızı A5",
    description:
      "Qnail Professional İpek Kirpik Cımbızı A5 – Onomac'ta! Etkileyici bakışlar için profesyonel kirpik ürünleri. Onomac güvencesiyle %100 orijinal, hızlı kargo ile hemen alın.",
    price: 109.9,
    image: "/images/products/ipek-kirpik-cimbizi-a5-twzr-a5.jpg",
    badge: "yeni",
    category: "Kirpik",
    inStock: true,
  },
  {
    slug: "qnail-silk-cat-eye",
    name: "Qnail Professional Kedi Gözü İpek Efektli Kalıcı Jel Oje Manyetik Cat Eye",
    description:
      "QNail Professional Kedi Gözü İpek Efektli Kalıcı Jel Oje, tırnaklarınızda derin, kadifemsi ve ışıltılı bir 3D efekt oluşturur. Yüksek pigmentli yapısı ve özel manyetik tozları sayesinde tırnaklarınıza salon kalitesinde \"cat eye\" görünümü kazandırır. Soyulmaya karşı dayanıklı ve uzun süre kalıcı formülüyle profesyonel ve kişisel kullanım için idealdir. 20 renk seçeneği ile sepette varyant seçerek sipariş verin.",
    price: 240,
    image: "/images/products/silk-cat-eye.png",
    hoverImage: "/images/products/silk-cat-eye-kartela.png",
    images: ["/images/products/silk-cat-eye.png", "/images/products/silk-cat-eye-kartela.png"],
    badge: "yeni",
    category: "Kalıcı Oje",
    inStock: true,
  },
];

export function getProductBySlug(slug: string): Product | undefined {
  return products.find((p) => p.slug === slug);
}

/**
 * Ürün galerisi — `images` doluysa onu (tekrarlar temizlenmiş), yoksa
 * geriye dönük uyumluluk için [image, hoverImage] döner.
 */
export function getProductImages(p: Pick<Product, "image" | "hoverImage" | "images">): string[] {
  if (p.images && p.images.length > 0) {
    const seen = new Set<string>();
    const out: string[] = [];
    for (const src of [p.image, ...p.images]) {
      if (src && !seen.has(src)) {
        seen.add(src);
        out.push(src);
      }
    }
    return out;
  }
  return [p.image, p.hoverImage].filter((s): s is string => Boolean(s));
}

/** İndirim yüzdesi (yuvarlak) — indirimsizse 0 döner. */
export function getDiscountPercent(p: { price: number; originalPrice?: number }): number {
  if (!p.originalPrice || p.originalPrice <= p.price) return 0;
  return Math.round((1 - p.price / p.originalPrice) * 100);
}

/** İndirimli ürünler. */
export function getDiscountedProducts(): Product[] {
  return products.filter((p) => getDiscountPercent(p) > 0);
}

export function getAllProductSlugs(): string[] {
  return products.map((p) => p.slug);
}
